import {
  GET_SPECIFICATION,
  GET_SPECIFICATION_VALUE,
  GET_MODEL,
  GET_MAKE,
  GET_VALUE_SET_FOR_SPECIFICATION,
  GET_SPECIFICATION_SET_FOR_GROUP,
  GET_SPECIFICATION_VALUE_SET,
  GET_SPECIFICATION_VALUE_SET_FILTER_VALUE,
  GET_ASSET_CATEGORY_FILTER_GROUP,
  // Asset //
  GET_ASSET,
  GET_SPECIFICATION_FOR_ASSET_GROUP,
  GET_ASSET_CATEGORY_FOR_ASSET,
  GET_COMPANY_FOR_ASSET_GROUP,
  GET_ASSET_STOCK_COMPANY,
  GET_LOCATION,
  GET_ASSET_TYPE_FOR_ASSET_FILTER,
  GET_INSURANCE_COMPANY,
  GET_ASSET_FILTER_COMPANY,
  GET_ASSET_FILTER_ALLOCATED,
  GET_ASSET_EXPORT,
  GET_ASSET_FILTER_GROUP,
  GET_ASSET_FILTER_CATEGORY,
  GET_ASSET_FILTER_DEPARTMENT,
  GET_ASSET_DETAIL,
  GET_ASSET_DEPRECIATION,
  GET_ASSET_HISTORY,
  GET_ASSET_ALLOCATION,
  GET_ASSET_STATUS,
  GET_ASSET_MAINTENANCE_SETTING,
  GET_ASSET_FUEL_DETAIL,
  GET_ASSET_VEHICLE_SERVICE_DETAIL,
  GET_ASSET_INSURANCE_ACTION,
  GENERATE_ASSET_ADMIN_EXPENSE,
  GET_ASSET_DOCUMENT,

  // DELETE_ASSET_SPECIFICATION,

  // Asset Insurance //
  GET_ASSET_INSURANCE,
  GET_ASSET_INSURANCE_DETAIL,

  // Asset Mainteance //
  GET_ASSET_MAINTENANCE,
  GET_ASSET_MAINTENANCE_DETAIL,
  GET_ASSET_MAINTENANCE_STATUS,
  GET_ASSET_MAINTENANCE_ALLOCATION,
  GET_DEMAND_DRAFT_REQUEST_FILTER_PROJECT,
  GET_DEMAND_DRAFT_REQUEST_FILTER_VENDOR,
  // Asset Transfer //
  GET_ASSET_TRANSFER,
  GET_ASSET_FOR_ASSET_TRANSFER,
  GET_ASSET_TRANSFER_DETAIL,
  GET_ASSET_TRANSFER_EXPORT,
  GET_ASSET_TRANSFER_FILTER_FROM_PROJECT,
  GET_ASSET_TRANSFER_FILTER_TO_PROJECT,
  GET_ASSET_TRANSFER_FOR_DC,
  GET_PROJECT_FOR_ASSET_TRANSFER,
  GET_ASSET_INSURANCE_EXPORT,
  GET_ASSET_MAINTENANCE_EXPORT,
  GET_ASSET_INSURANCE_FILTER_VENDOR,
  GET_ASSET_DETAIL_PRINT,

  // Asset Lieance
  GET_LICENSE,
  // License
  GET_ASSET_LICENSE_DETAIL,
  GET_ASSET_LICENSE,
  GET_ASSET_LICENSE_EXPORT,
  GET_ASSET_LICENSE_FILTER_VENDOR,
  GET_ASSET_GROUP_MASTER,
  GET_ASSET_CATEGORY,

  // Asset Insurance
  GET_ASSET_INSURANCE_NUMBER,
  // Asset Insurance type
  GET_INSURANCE_TYPE,
  // Asset License Type
  GET_LICENSE_TYPE,
  // Asset License in Review form
  GET_ASSET_LICENSE_NUMBER
} from "./types";

const initialState = {
  getValueSetForSpecification: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSpecificationSetForGroup: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // Asset //
  getAsset: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSpecificationForAssetGroup: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetFilterGroup: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getCompanyForAssetGroup: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetFilterAllocated: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetFilterCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetStockCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getLocation: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetTypeForAssetFilter: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetInsurance: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getInsuranceCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetFilterCompany: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetFilterDepartment: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetDepreciation: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetHistory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetAllocation: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetMaintenanceSetting: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // Asset Mainteance //
  getAssetMaintenance: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetMaintenanceDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetMaintenanceStatus: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetMaintenanceAllocation: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetVehicleServiceDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetFuelDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetInsuranceDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetCategoryFilterGroup: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetInsuranceAction: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  generateAssetAdminExpense: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetDocument: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // Asset Transfer //
  getAssetTransfer: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetForAssetTransfer: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetTransferDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetTransferExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetTransferFilterFromProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetTransferFilterToProject: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetTransferForDC: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetInsuranceExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getProjectForAssetTransfer: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetMaintenanceExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetInsuranceFilterVendor: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetDetailPrint: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // Asset Lieance
  getLicense: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // License
  getAssetLicense: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetLicenseDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetLicenseExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetLicenseFilterVendor: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // Asset Category and Group
  getAssetCategory: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getAssetGroupMaster: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },

  // Asset Insurance
  getAssetInsuranceNumber: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // Asset Insurance Type
  getInsuranceType: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // Asset License Type
  getLicenseType: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  // Asset License in Review form
  getAssetLicenseNumber: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSpecification: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSpecificationValue: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getModel: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getMake: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSpecificationValueSetFilterValue: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getSpecificationValueSet: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  }
};

const AssestsAccount_reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_SPECIFICATION:
      return Object.assign({}, state, {
        getSpecification: payload
      });
    case GET_SPECIFICATION_VALUE:
      return Object.assign({}, state, {
        getSpecificationValue: payload
      });
    case GET_MODEL:
      return Object.assign({}, state, {
        getModel: payload
      });
    case GET_MAKE:
      return Object.assign({}, state, {
        getMake: payload
      });

    case GET_VALUE_SET_FOR_SPECIFICATION:
      return Object.assign({}, state, {
        getValueSetForSpecification: payload
      });
    case GET_SPECIFICATION_SET_FOR_GROUP:
      return Object.assign({}, state, {
        getSpecificationSetForGroup: payload
      });
    //Assest
    case GET_ASSET:
      return Object.assign({}, state, {
        getAsset: payload
      });

    case GET_SPECIFICATION_FOR_ASSET_GROUP:
      return Object.assign({}, state, {
        getSpecificationForAssetGroup: payload
      });

    case GET_ASSET_FILTER_GROUP:
      return Object.assign({}, state, {
        getAssetFilterGroup: payload
      });

    case GET_COMPANY_FOR_ASSET_GROUP:
      return Object.assign({}, state, {
        getCompanyForAssetGroup: payload
      });
    case GET_ASSET_EXPORT:
      return Object.assign({}, state, {
        getAssetExport: payload
      });

    case GET_ASSET_STOCK_COMPANY:
      return Object.assign({}, state, {
        getAssetStockCompany: payload
      });
    case GET_LOCATION:
      return Object.assign({}, state, {
        getLocation: payload
      });
    case GET_ASSET_TYPE_FOR_ASSET_FILTER:
      return Object.assign({}, state, {
        getAssetTypeForAssetFilter: payload
      });
    case GET_ASSET_INSURANCE:
      return Object.assign({}, state, {
        getAssetInsurance: payload
      });
    case GET_INSURANCE_COMPANY:
      return Object.assign({}, state, {
        getInsuranceCompany: payload
      });
    case GET_ASSET_FILTER_COMPANY:
      return Object.assign({}, state, {
        getAssetFilterCompany: payload
      });
    case GET_ASSET_FILTER_CATEGORY:
      return Object.assign({}, state, {
        getAssetFilterCategory: payload
      });
    case GET_ASSET_FILTER_DEPARTMENT:
      return Object.assign({}, state, {
        getAssetFilterDepartment: payload
      });
    case GET_ASSET_FILTER_ALLOCATED:
      return Object.assign({}, state, {
        getAssetFilterAllocated: payload
      });

    case GET_ASSET_DETAIL:
      return Object.assign({}, state, {
        getAssetDetail: payload
      });
    case GET_ASSET_DEPRECIATION:
      return Object.assign({}, state, {
        getAssetDepreciation: payload
      });
    case GET_ASSET_HISTORY:
      return Object.assign({}, state, {
        getAssetHistory: payload
      });
    case GET_ASSET_ALLOCATION:
      return Object.assign({}, state, {
        getAssetAllocation: payload
      });
    case GET_ASSET_STATUS:
      return Object.assign({}, state, {
        getAssetStatus: payload
      });
    case GET_ASSET_MAINTENANCE_SETTING:
      return Object.assign({}, state, {
        getAssetMaintenanceSetting: payload
      });
    case GET_ASSET_MAINTENANCE:
      return Object.assign({}, state, {
        getAssetMaintenance: payload
      });
    case GET_ASSET_MAINTENANCE_DETAIL:
      return Object.assign({}, state, {
        getAssetMaintenanceDetail: payload
      });
    case GET_ASSET_MAINTENANCE_STATUS:
      return Object.assign({}, state, {
        getAssetMaintenanceStatus: payload
      });
    case GET_ASSET_MAINTENANCE_ALLOCATION:
      return Object.assign({}, state, {
        getAssetMaintenanceAllocation: payload
      });
    case GET_ASSET_FUEL_DETAIL:
      return Object.assign({}, state, {
        getAssetFuelDetail: payload
      });
    case GET_ASSET_VEHICLE_SERVICE_DETAIL:
      return Object.assign({}, state, {
        getAssetVehicleServiceDetail: payload
      });
    case GET_ASSET_INSURANCE_DETAIL:
      return Object.assign({}, state, {
        getAssetInsuranceDetail: payload
      });
    case GET_ASSET_INSURANCE_ACTION:
      return Object.assign({}, state, {
        getAssetInsuranceAction: payload
      });
    case GENERATE_ASSET_ADMIN_EXPENSE:
      return Object.assign({}, state, {
        generateAssetAdminExpense: payload
      });
    case GET_ASSET_DOCUMENT:
      return Object.assign({}, state, {
        getAssetDocument: payload
      });

    // Asset Transfer //
    case GET_ASSET_TRANSFER:
      return Object.assign({}, state, {
        getAssetTransfer: payload
      });
    case GET_ASSET_FOR_ASSET_TRANSFER:
      return Object.assign({}, state, {
        getAssetForAssetTransfer: payload
      });
    case GET_ASSET_TRANSFER_DETAIL:
      return Object.assign({}, state, {
        getAssetTransferDetail: payload
      });
    case GET_ASSET_TRANSFER_EXPORT:
      return Object.assign({}, state, {
        getAssetTransferExport: payload
      });
    case GET_ASSET_TRANSFER_FILTER_TO_PROJECT:
      return Object.assign({}, state, {
        getAssetTransferFilterToProject: payload
      });
    case GET_ASSET_TRANSFER_FILTER_FROM_PROJECT:
      return Object.assign({}, state, {
        getAssetTransferFilterFromProject: payload
      });
    case GET_ASSET_TRANSFER_FOR_DC:
      return Object.assign({}, state, {
        getAssetTransferForDC: payload
      });
    case GET_PROJECT_FOR_ASSET_TRANSFER:
      return Object.assign({}, state, {
        getProjectForAssetTransfer: payload
      });
    case GET_ASSET_MAINTENANCE_EXPORT:
      return Object.assign({}, state, {
        getAssetMaintenanceExport: payload
      });
    case GET_ASSET_INSURANCE_EXPORT:
      return Object.assign({}, state, {
        getAssetInsuranceExport: payload
      });
    case GET_ASSET_INSURANCE_FILTER_VENDOR:
      return Object.assign({}, state, {
        getAssetInsuranceFilterVendor: payload
      });
    case GET_ASSET_DETAIL_PRINT:
      return Object.assign({}, state, {
        getAssetDetailPrint: payload
      });
    // Asset Lieance
    case GET_LICENSE:
      return Object.assign({}, state, {
        getLicense: payload
      });

    //  License
    case GET_ASSET_LICENSE:
      return Object.assign({}, state, {
        getAssetLicense: payload
      });
    case GET_ASSET_LICENSE_DETAIL:
      return Object.assign({}, state, {
        getAssetLicenseDetail: payload
      });
    case GET_ASSET_LICENSE_EXPORT:
      return Object.assign({}, state, {
        getAssetLicenseExport: payload
      });
    case GET_ASSET_LICENSE_FILTER_VENDOR:
      return Object.assign({}, state, {
        getAssetLicenseFilterVendor: payload
      });
    // Asset Group and Category
    case GET_ASSET_CATEGORY:
      return Object.assign({}, state, {
        getAssetCategory: payload
      });
    case GET_ASSET_GROUP_MASTER:
      return Object.assign({}, state, {
        getAssetGroupMaster: payload
      });

    // Asset Insurance
    case GET_ASSET_INSURANCE_NUMBER:
      return Object.assign({}, state, {
        getAssetInsuranceNumber: payload
      });
    // Asset Insurance Type
    case GET_INSURANCE_TYPE:
      return Object.assign({}, state, {
        getInsuranceType: payload
      });

    // Asset License Type
    case GET_LICENSE_TYPE:
      return Object.assign({}, state, {
        getLicenseType: payload
      });
    // Asset License in Review form
    case GET_ASSET_LICENSE_NUMBER:
      return Object.assign({}, state, {
        getAssetLicenseNumber: payload
      });
    case GET_ASSET_CATEGORY_FILTER_GROUP:
      return Object.assign({}, state, {
        getAssetCategoryFilterGroup: payload
      });
    case GET_SPECIFICATION_VALUE_SET_FILTER_VALUE:
      return Object.assign({}, state, {
        getSpecificationValueSetFilterValue: payload
      });
    case GET_SPECIFICATION_VALUE_SET:
      return Object.assign({}, state, {
        getSpecificationValueSet: payload
      });
    default:
      return state;
  }
};

export default AssestsAccount_reducer;
